// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetBuildingGroups-modulebuildingGroupsContent__xuJYG WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "RequestProfileWidgetBuildingGroups-moduleitemsListTitleWrapper__xtDWa WidgetContentItemsList-moduletitleWrapper__Wdg5G";
export { _1 as "buildingGroupsContent", _2 as "itemsListTitleWrapper" }
